import { Truck, Plane, Ship, Boxes, Anchor, HardHat } from "lucide-react";

const u = (id, w = 1600) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  u,
  hero: u("1597334948330-38795f25d05d", 2000),
  truck: u("1601584115197-04ecc0da31d7"),
  truckSunset: u("1616432043562-3671ea2e5242"),
  truckDark: u("1592838064575-70ed626d3a0e"),
  truckRoad: u("1695222833131-54ee679ae8e5"),
  port: u("1691591765923-3bd6f12f4209"),
  air: u("1571086291540-b137111fa1c7"),
  airLoading: u("1583911026662-95161686d9a6"),
  warehouse: u("1740914994657-f1cdffdc418e"),
};

export const CONTACT = {
  phone: "0530 633 06 24",
  phoneHref: "tel:+905306330624",
  email: "info@mvalog.com",
  address: "Kültür Mh. İclal Tan Sk. No:2 Güven Apt. Kat:7 Daire:21 Akdeniz / Mersin",
  city: "Mersin, Türkiye",
  mapQuery: "İclal Tan Sokağı, Kültür, Akdeniz, Mersin",
};

export const BRAND = { slogan: "From Good to Great" };

export const SERVICES = [
  {
    id: "road",
    icon: Truck,
    image: u("1601584115197-04ecc0da31d7"),
    en: {
      title: "Road Transport",
      desc: "Full and partial road freight across Türkiye, Europe and the Middle East with a modern, GPS-tracked fleet and door-to-door control.",
      bullets: ["Full (FTL) and partial (LTL) loads", "Europe, Middle East and Türkiye-wide", "GPS-tracked modern fleet", "Door-to-door delivery"],
    },
    tr: {
      title: "Karayolu Taşımacılığı",
      desc: "Modern, GPS takipli filomuzla Türkiye, Avrupa ve Orta Doğu genelinde tam ve parsiyel karayolu taşımacılığı, kapıdan kapıya kontrolle.",
      bullets: ["Tam (FTL) ve parsiyel (LTL) yükler", "Avrupa, Orta Doğu ve Türkiye geneli", "GPS takipli modern filo", "Kapıdan kapıya teslimat"],
    },
  },
  {
    id: "air",
    icon: Plane,
    image: u("1571086291540-b137111fa1c7"),
    en: {
      title: "Air Freight",
      desc: "Time-critical air cargo solutions with express handling and customs clearance through major global airports.",
      bullets: ["Time-critical and express cargo", "Consolidated and direct shipments", "Express customs clearance", "Airport-to-door service"],
    },
    tr: {
      title: "Hava Yolu Taşımacılığı",
      desc: "Dünya'nın önemli havalimanları üzerinden, ekspres elleçleme ve gümrükleme desteğiyle zaman kritik hava kargo çözümleri.",
      bullets: ["Zaman kritik ve ekspres yükler", "Konsolide ve direkt sevkiyatlar", "Ekspres gümrükleme", "Havalimanı-kapı servis"],
    },
  },
  {
    id: "container",
    icon: Ship,
    image: u("1691591765923-3bd6f12f4209"),
    en: {
      title: "Container Transport (FCL / LCL)",
      desc: "Full container (FCL) and consolidated (LCL) ocean shipments from Mersin to ports worldwide.",
      bullets: ["20' / 40' / HC and special equipment", "Full container (FCL) shipments", "Consolidated partial loads (LCL)", "Worldwide ports via Mersin"],
    },
    tr: {
      title: "Konteyner Taşımacılığı (FCL / LCL)",
      desc: "Mersin'den dünya limanlarına tam konteyner (FCL) ve konsolide (LCL) deniz sevkiyatları.",
      bullets: ["20' / 40' / HC ve özel ekipman", "Tam konteyner (FCL) sevkiyatları", "Konsolide parsiyel yükler (LCL)", "Mersin'den tüm dünya limanlarına"],
    },
  },
  {
    id: "ftl",
    icon: Boxes,
    image: null,
    en: {
      title: "FTL / LTL",
      desc: "Dedicated full truckload and cost-efficient less-than-truckload options for every size of cargo.",
      bullets: ["Dedicated full truckload (FTL)", "Cost-efficient partial loads (LTL)", "Flexible vehicles — tautliner, reefer, tank", "Optimized loading and routing"],
    },
    tr: {
      title: "FTL / LTL (Tam Tır / Parsiyel)",
      desc: "Her yük boyutu için özel tam tır yükü (FTL) ve ekonomik parsiyel (LTL) seçenekleri.",
      bullets: ["Özel tam tır yükü (FTL)", "Ekonomik parsiyel taşıma (LTL)", "Esnek araç tipleri — perdeli, frigo, tank", "Optimize yükleme ve güzergah"],
    },
  },
  {
    id: "charter",
    icon: Anchor,
    image: null,
    en: {
      title: "Charter Services",
      desc: "Dedicated vessel and aircraft chartering for bulk, heavy-lift and time-critical project moves.",
      bullets: ["Dry and refrigerated vessel chartering", "Cargo aircraft chartering", "Bulk, heavy-lift and out-of-gauge moves", "Port and berth coordination"],
    },
    tr: {
      title: "Charter Hizmetleri",
      desc: "Dökme, ağır ve zaman kritik proje taşımaları için özel gemi ve uçak charter hizmetleri.",
      bullets: ["Kuru ve frigorifik gemi charter", "Kargo uçağı charter", "Dökme, ağır ve gabari dışı taşımalar", "Liman ve iskele koordinasyonu"],
    },
  },
  {
    id: "project",
    icon: HardHat,
    image: null,
    en: {
      title: "Project Cargo",
      desc: "End-to-end engineering, route surveys and escorts for out-of-gauge and heavy-lift cargo.",
      bullets: ["Route surveys and feasibility", "Lifting engineering and permits", "Escort and supervision services", "Turnkey door-to-site delivery"],
    },
    tr: {
      title: "Proje Taşımacılığı",
      desc: "Gabari dışı ve ağır yükler için uçtan uca mühendislik, güzergah etüdü ve refakat hizmetleri.",
      bullets: ["Güzergah etüdü ve fizibilite", "Kaldırma mühendisliği ve izinler", "Refakat ve nezaret hizmetleri", "Anahtar teslim kapıdan sahaya"],
    },
  },
];

export const en = {
  topbar: { hours: "Mon – Sat · 08:30 – 18:30" },
  nav: { home: "Home", about: "About Us", services: "Services", references: "References", contact: "Contact", quote: "Get a Quote" },
  hero: {
    eyebrow: "Mersin, Türkiye — International Transport",
    titleA: "Global Freight &",
    titleB: "Precision Logistics",
    subtitle: "MVALOG Int. Transport Co. Ltd. moves your cargo across Türkiye, Europe, the Middle East and the world — by road, sea and air.",
    ctaPrimary: "Get a Quote",
    ctaSecondary: "Our Services",
    badges: ["Founded 2023", "Headquarters: Mersin", "Road · Sea · Air", "FCL / LCL — FTL / LTL"],
  },
  homeAbout: {
    eyebrow: "About MVALOG",
    title: "A new-generation logistics partner from the heart of Mersin",
    p1: "Founded in 2023 in Mersin — one of the Mediterranean's most strategic port hubs — MVALOG Int. Transport Co. Ltd. combines modern fleet management with deep forwarding expertise.",
    p2: "From full truckloads to out-of-gauge project cargo, we plan, execute and monitor every shipment end-to-end, bridging East and West with reliable supply chain execution.",
    points: ["Road, sea and air freight under one roof", "FCL / LCL container and FTL / LTL solutions", "Charter and project cargo expertise"],
    link: "More About Us",
    statValue: "2023",
    statLabel: "Founded in Mersin",
    statSub: "Your bridge between East & West",
  },
  homeServices: {
    eyebrow: "What We Do",
    title: "Logistics services built around your cargo",
    subtitle: "Six core service lines covering every mode, size and deadline.",
    link: "View All Services",
    cardLink: "Detail",
  },
  ctaBand: {
    title: "Have cargo to move?",
    subtitle: "Tell us the route — we handle the rest, from pickup to final delivery.",
    button: "Request a Quote",
  },
  aboutPage: {
    eyebrow: "About Us",
    title: "Carrying the world's trade since 2023 — across Europe, the Middle East and Asia",
    subtitle: "With the experience we have built from past to present, we move forward with honest, solid and principled steps — striving for a more honest, safer and stronger future.",
    storyEyebrow: "Our Story",
    storyTitle: "Built in Mersin, driving worldwide",
    storyP1: "MVALOG Int. Transport Co. Ltd. was founded in 2023 in Mersin, at the crossroads of the Mediterranean's busiest trade corridors. From day one, our goal has been simple: make international transport clear, reliable and personal.",
    storyP2: "We combine a modern, GPS-tracked fleet with an experienced operations team that treats every shipment like its own — a full container to Hamburg, a partial load to Baghdad, or a charter sailing across continents.",
    missionTitle: "Our Mission",
    missionText: "To deliver dependable, transparent and efficient transport services that give our customers full control and peace of mind over their supply chain.",
    visionTitle: "Our Vision",
    visionText: "To become a leading logistics brand recognized for precision, integrity and customer-first service on every trade lane we serve.",
    valuesTitle: "Our Values",
    values: [
      { title: "Reliability", text: "Commitments kept, deadlines met — shipment after shipment." },
      { title: "Transparency", text: "Clear pricing, honest communication and real-time updates." },
      { title: "Agility", text: "Fast decisions and flexible solutions for changing cargo needs." },
      { title: "Customer Focus", text: "Boutique service in line with our customers' interests, from first quote to final delivery." },
    ],
    founderEyebrow: "Founder",
    founderName: "Murat HOSTA",
    founderBio: [
      "Murat Hosta grew up in a transport family and took his first steps in the industry from the ground up — gaining experience in transit and port operations at a customs firm even before his university education.",
      "He completed his education in England: language studies at London City College and Maritime Management at LCC and Schiller American University London. During his student years, he interned at Lloyd's of London and Lloyd's Register, and also gained experience at the Port of Dover in port operations, road-freight transit procedures and port handling.",
      "After returning to Türkiye, he built his experience across air, road and sea freight, and in 2023 he began serving the industry under his own company, MVALOG. A father of one, he is a businessman who leads MVALOG with its 'From Good to Great' vision.",
    ],
  },
  servicesPage: {
    eyebrow: "Our Services",
    title: "Every mode. Every route. One partner.",
    subtitle: "From daily truckload departures to complex project cargo, MVALOG covers the full journey of your freight.",
    bulletsLabel: "What's included",
    processTitle: "How we work",
    process: ["Request & Quote", "Planning & Routing", "Transport & Monitoring", "Delivery & Reporting"],
  },
  referencesPage: {
    eyebrow: "References",
    title: "Trusted by industries that move",
    subtitle: "We serve manufacturers, traders and exporters across a wide range of sectors.",
    placeholderLabel: "Reference",
    note: "Client logos and detailed references will be published here. Your company could be next.",
    ctaButton: "Become a Reference",
  },
  industries: ["Automotive", "Textile & Apparel", "Retail & FMCG", "Construction", "Agriculture & Food", "Chemicals", "Machinery", "Energy"],
  contactPage: {
    eyebrow: "Contact",
    title: "Let's move your cargo",
    subtitle: "Request a quote or ask us anything — our team replies within one business day.",
    infoTitle: "Head Office",
    addressLabel: "Address",
    phoneLabel: "Phone",
    emailLabel: "E-Mail",
    hoursLabel: "Working Hours",
    hours: "Mon – Sat · 08:30 – 18:30",
    mapTitle: "Mersin, Türkiye",
    formTitle: "Request a Quote",
    formSubtitle: "Fill in the form and we will get back to you shortly.",
    name: "Full Name",
    namePh: "John Doe",
    company: "Company",
    companyPh: "Company Ltd.",
    email: "E-Mail",
    emailPh: "you@company.com",
    phone: "Phone",
    phonePh: "+90 5__ ___ __ __",
    service: "Service of Interest",
    message: "Your Message",
    messagePh: "Cargo type, route, weight, volume…",
    submit: "Send Request",
    sending: "Sending…",
    successTitle: "Request received!",
    successText: "Thank you — our team will contact you shortly.",
    errorText: "Something went wrong. Please try again.",
    required: "Required fields are marked with *",
  },
  footer: {
    blurb: "International road, sea and air transport from Mersin, Türkiye — founded 2023.",
    linksTitle: "Quick Links",
    servicesTitle: "Services",
    contactTitle: "Contact",
    rights: "All rights reserved.",
  },
  general: { generalEnquiry: "General Enquiry" },
};

export const tr = {
  topbar: { hours: "Pzt – Cmt · 08:30 – 18:30" },
  nav: { home: "Anasayfa", about: "Hakkımızda", services: "Hizmetler", references: "Referanslar", contact: "İletişim", quote: "Teklif Al" },
  hero: {
    eyebrow: "Mersin, Türkiye — Uluslararası Taşımacılık",
    titleA: "Küresel Yük &",
    titleB: "Hassas Lojistik",
    subtitle: "MVALOG Uluslararası Taşımacılık, yükünüzü Türkiye, Avrupa, Orta Doğu ve dünyanın her yerine karayolu, denizyolu ve havayolu ile güvenle taşır.",
    ctaPrimary: "Teklif Al",
    ctaSecondary: "Hizmetlerimiz",
    badges: ["2023'te Kuruldu", "Merkez: Mersin", "Karayolu · Deniz · Hava", "FCL / LCL — FTL / LTL"],
  },
  homeAbout: {
    eyebrow: "MVALOG Hakkında",
    title: "Mersin'in kalbinden yeni nesil bir lojistik ortağı",
    p1: "2023 yılında, Akdeniz'in en stratejik liman merkezlerinden Mersin'de kurulan MVALOG Uluslararası Taşımacılık, modern filo yönetimini derin sevkiyat uzmanlığıyla birleştirir.",
    p2: "Tam tır yükünden gabari dışı proje taşımalarına kadar her sevkiyatı baştan sona planlar, yürütür ve izler; Doğu ile Batı arasında güvenilir bir tedarik zinciri köprüsü kurarız.",
    points: ["Karayolu, denizyolu ve havayolu tek çatı altında", "FCL / LCL konteyner ve FTL / LTL çözümleri", "Charter ve proje taşımacılığı uzmanlığı"],
    link: "Hakkımızda Daha Fazla",
    statValue: "2023",
    statLabel: "Mersin'de kuruldu",
    statSub: "Doğu ile Batı arasındaki köprünüz",
  },
  homeServices: {
    eyebrow: "Ne Yapıyoruz",
    title: "Yükünüzün etrafında tasarlanan lojistik hizmetleri",
    subtitle: "Her taşıma modunu, boyutu ve teslim tarihini kapsayan altı ana hizmet hattı.",
    link: "Tüm Hizmetleri Gör",
    cardLink: "Detay",
  },
  ctaBand: {
    title: "Taşınacak yükünüz mü var?",
    subtitle: "Rotayı bize söyleyin — alımdan teslimata kadar gerisini biz hallediyoruz.",
    button: "Teklif İsteyin",
  },
  aboutPage: {
    eyebrow: "Hakkımızda",
    title: "2023'ten bu yana başta Avrupa, Orta Doğu ve Asya olmak üzere bütün dünya ticaretini taşıyoruz",
    subtitle: "Geçmişten günümüze edindiğimiz tecrübe ile geleceğe dürüst, sağlam ve ilkeli adımlarla ilerliyoruz. Daha dürüst, daha güvenli ve daha güçlü bir geleceği inşa etmek için çabalıyoruz.",
    storyEyebrow: "Hikayemiz",
    storyTitle: "Mersin'de kurulduk, tüm dünyaya ulaşıyoruz",
    storyP1: "MVALOG Uluslararası Taşımacılık, 2023 yılında Akdeniz'in en yoğun ticaret koridorlarının kesişiminde yer alan Mersin'de kuruldu. İlk günden beri hedefimiz basit: uluslararası taşımacılığı anlaşılır, güvenilir ve samimi hale getirmek.",
    storyP2: "Modern, GPS takipli filomuzu, her sevkiyat kendi işi gibi gören deneyimli operasyon ekibimizle birleştiriyoruz — Hamburg'a tam konteyner, Bağdat'a parsiyel yük ya da kıtalar arası bir charter seferi; hangisi olursa olsun.",
    missionTitle: "Misyonumuz",
    missionText: "Müşterilerimize tedarik zincirleri üzerinde tam kontrol ve iç huzuru yaşatan, güvenilir, şeffaf ve verimli taşımacılık hizmetleri sunmak.",
    visionTitle: "Vizyonumuz",
    visionText: "Hizmet verdiğimiz her ticaret hattında hassasiyeti, dürüstlüğü ve müşteri odaklılığıyla tanınan öncü bir lojistik markası olmak.",
    valuesTitle: "Değerlerimiz",
    values: [
      { title: "Güvenilirlik", text: "Söz verilen gününde teslim — sevkiyattan sevkiyata." },
      { title: "Şeffaflık", text: "Net fiyat, açık iletişim ve anlık bilgilendirme." },
      { title: "Çeviklik", text: "Değişen yük ihtiyaçlarına hızlı karar ve esnek çözümler." },
      { title: "Müşteri Odaklılık", text: "İlk tekliften son teslimata müşterilerimizin çıkarı doğrultusunda butik hizmet." },
    ],
    founderEyebrow: "Kurucu",
    founderName: "Murat HOSTA",
    founderBio: [
      "Murat Hosta, nakliyeci bir ailede yetişti ve üniversite eğitiminden önce bir gümrük firmasında transit ile liman işlemleri alanında çalışarak sektöre sıfırdan, sahadan adım attı.",
      "Eğitimini İngiltere'de tamamladı: London City College'da dil eğitimi aldı; LCC ve Schiller American University London'da deniz işletmeciliği okudu. Öğrencilik yıllarında Lloyd's of London ve Lloyd's Register'da staj yaptı, ayrıca liman operasyonları, kara nakliyesi transit işlemleri ve liman işlemleri üzerine Dover Limanı'nda deneyim kazandı.",
      "Türkiye'ye döndükten sonra hava, kara ve deniz taşımalarının her alanında deneyim kazanan Hosta, 2023 yılında kendi firması MVALOG ile sektöre hizmet vermeye başladı. Bir çocuk babası olan Hosta, iş insanı kimliğiyle MVALOG'u 'From Good to Great' vizyonuyla yönetiyor.",
    ],
  },
  servicesPage: {
    eyebrow: "Hizmetlerimiz",
    title: "Her mod. Her rota. Tek ortağınız.",
    subtitle: "Günlük tır kalkışlarından karmaşık proje taşımalarına kadar, MVALOG yükünüzün tüm yolculuğunu kapsar.",
    bulletsLabel: "Kapsam",
    processTitle: "Nasıl çalışıyoruz",
    process: ["Talep & Teklif", "Planlama & Rota", "Taşıma & İzleme", "Teslimat & Raporlama"],
  },
  referencesPage: {
    eyebrow: "Referanslar",
    title: "Ticareti hareket ettiren sektörlerin güveni",
    subtitle: "Üreticilerden ticaretçilere, ihracatçılara kadar geniş bir sektör yelpazesine hizmet veriyoruz.",
    placeholderLabel: "Referans",
    note: "Müşteri logoları ve detaylı referanslar burada yer alacak. Sırada sizin şirketiniz olabilir.",
    ctaButton: "Referansımız Olun",
  },
  industries: ["Otomotiv", "Tekstil & Hazır Giyim", "Perakende & FMCG", "İnşaat", "Tarım & Gıda", "Kimya", "Makine", "Enerji"],
  contactPage: {
    eyebrow: "İletişim",
    title: "Yükünüzü birlikte taşıyalım",
    subtitle: "Teklif isteyin ya da bize sorun — ekibimiz bir iş günü içinde yanıtlar.",
    infoTitle: "Genel Merkez",
    addressLabel: "Adres",
    phoneLabel: "Telefon",
    emailLabel: "E-Posta",
    hoursLabel: "Çalışma Saatleri",
    hours: "Pzt – Cmt · 08:30 – 18:30",
    mapTitle: "Mersin, Türkiye",
    formTitle: "Teklif Formu",
    formSubtitle: "Formu doldurun, kısa sürede size dönüş yapalım.",
    name: "Ad Soyad",
    namePh: "Adınız Soyadınız",
    company: "Firma",
    companyPh: "Firma Adı Ltd.",
    email: "E-Posta",
    emailPh: "siz@firma.com",
    phone: "Telefon",
    phonePh: "+90 5__ ___ __ __",
    service: "İlgilendiğiniz Hizmet",
    message: "Mesajınız",
    messagePh: "Yük türü, rota, ağırlık, hacim…",
    submit: "Talebi Gönder",
    sending: "Gönderiliyor…",
    successTitle: "Talebiniz alındı!",
    successText: "Teşekkürler — ekibimiz en kısa sürede sizinle iletişime geçecek.",
    errorText: "Bir sorun oluştu. Lütfen tekrar deneyin.",
    required: "* ile işaretli alanlar zorunludur",
  },
  footer: {
    blurb: "Mersin, Türkiye merkezli uluslararası karayolu, denizyolu ve havayolu taşımacılığı — 2023.",
    linksTitle: "Hızlı Bağlantılar",
    servicesTitle: "Hizmetler",
    contactTitle: "İletişim",
    rights: "Tüm hakları saklıdır.",
  },
  general: { generalEnquiry: "Genel Talep" },
};
